var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{style:({
      marginBottom: '16px',
      fontWeight: 'bold',
    })},[_vm._v(" Category ")]),_vm._l((_vm.categoryTree),function(category){return _c('CategoryItem',{key:category.id,attrs:{"checked":_vm.isSelected(category.id),"checkedSubcategories":_vm.selectedCategories,"category":category},on:{"select":_vm.handleSelectFilters,"deselect":_vm.handleDeselectFilters}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }